/**
 * OpenAI Speech-to-Text (Whisper) Types
 *
 * Type definitions for OpenAI Whisper API integration
 */

import { z } from 'zod';

/**
 * STT transcription options (subset of request, used for service calls)
 */
export const STTTranscriptionOptionsSchema = z.object({
  language: z.string().optional().describe('ISO-639-1 language code (e.g., "en", "es")'),
  prompt: z.string().max(256).optional().describe('Context to guide transcription'),
  temperature: z.number().min(0).max(1).optional().describe('Sampling temperature (0-1)'),
});
export type STTTranscriptionOptions = z.infer<typeof STTTranscriptionOptionsSchema>;

/**
 * STT transcription request
 */
export const STTTranscriptionRequestSchema = z.object({
  audio: z.string().describe('Base64 encoded audio data'),
  mimeType: z.string().describe('Audio MIME type (e.g., audio/webm)'),
  language: z.string().optional(),
  prompt: z.string().max(256).optional(),
  temperature: z.number().min(0).max(1).optional(),
});

export type STTTranscriptionRequest = z.infer<typeof STTTranscriptionRequestSchema>;

/**
 * STT transcription response
 */
export const STTTranscriptionResponseSchema = z.object({
  text: z.string().describe('Transcribed text'),
  language: z.string().optional().describe('Detected language'),
  duration: z.number().optional().describe('Audio duration in seconds'),
});

export type STTTranscriptionResponse = z.infer<typeof STTTranscriptionResponseSchema>;
